export function slugifyMarketInsightTitle(title = "") {
  return String(title)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

export function attachMarketInsightSlugs(reports = []) {
  const used = new Map();
  return (reports || []).map((report, index) => {
    const base =
      report?.attributes?.slug ||
      slugifyMarketInsightTitle(report?.attributes?.title) ||
      `report-${index + 1}`;

    const timesUsed = used.get(base) || 0;
    used.set(base, timesUsed + 1);

    const slug = timesUsed ? `${base}-${timesUsed + 1}` : base;

    return { ...report?.attributes, slug };
  });
}

export function attachMarketInsightBySlug(report = {}) {
  const used = new Map();

  const base =
    report?.attributes?.slug ||
    slugifyMarketInsightTitle(report?.attributes?.title);

  const timesUsed = used.get(base) || 0;
  used.set(base, timesUsed + 1);

  const slug = timesUsed ? `${base}-${timesUsed + 1}` : base;

  return { ...report?.attributes, slug };
}
